
import f1 from '../assets/images/f1.webp';
import f2 from '../assets/images/f2.webp';
import f3 from '../assets/images/f3.webp';
import f4 from '../assets/images/f4.webp';
import f5 from '../assets/images/f5.webp';
import f6 from '../assets/images/f6.webp';
const testimonials = [
    {
        name: "Fatima Iqbal",
        subtitle: "6 Rezensionen · 7 Fotos",
        time: "vor 5 Monaten",
        stars: 5,
        cost: "10–20 €",
        review: "Went there with my family today for the first time, will surely be our regular spot. Loved the service, the food and the cosy setting. It was exceptionally clean despite being so busy. The staff were all very friendly, the food was delicious and warm ..",
        images: [f1]

    },
    {
        name: "Süleyman Cosgun",
        subtitle: "Local Guide · 65 Rezensionen · 64 Fotos",
        time: "vor 5 Monaten",
        stars: 5,
        cost: "20–30 €",
        review: "Die Mitarbeiter waren sehr nett und freundlich. Das Essen 10 von 10! Wenn wir wieder in Berlin sind, werden wir auf jeden Fall wieder hier essen.",
        images: [f2]

    },

    {
        name: "Lucas Huynh",
        subtitle: "3 Rezensionen · 4 Fotos",
        time: "vor 2 Monaten",
        stars: 5,
        cost: "90–100 €",
        review: "The food was exquisite and the salmon just melts in your mouth and the staff was very friendly...",
        images: [f3]

    },
    {
        name: "Meryem Eray",
        subtitle: "Local Guide · 19 Rezensionen · 34 Fotos",
        time: "vor einem Monat",
        stars: 5,
        cost: "10–20 €",
        review: "Das beste Beef Pho, was ich je in meinem Leben hatte. Keine Wörter, es war einfach richtig lecker und die Brühe hat sich wie eine umarmung angefühlt. Ich empfehle es gerne weiter und komme auf jeden Fall hier wieder, um diesen Pho nochaml zu essen ❤️ ...",
        images: [f4]

    },
    {
        name: "Noor jawad",
        subtitle: "Local Guide · 68 Rezensionen · 52 Fotos",
        time: "vor 5 Monaten",
        stars: 5,
        cost: "10–20 €",
        review: "Authentisches Essen, super service, freundliche Kellner, gute preise, wir werden definitiv wiederkommen 👍🏽 ....",
        images: [f5]

    },
    {
        name: "Resul Öztürk",
        subtitle: "Local Guide · 40 Rezensionen · 124 Fotos",
        time: "vor 3 Monaten",
        stars: 5,
        cost: "10–20 €",
        review: "Das Essen hat super geschmeckt wie immer. Wenn ihr de asiatische Küche qualitativ und noch Helal genießen wollt, ist hello Charge eine sehr gute Alternative. ... ",
        images: [f6]

    },

];

export default testimonials;
